import React from "react";

const Breaker = ({ title, hidden }) => {
    if (!hidden) {
        return (
            <div className="breaker">
                <span>{title.toUpperCase()}</span>
            </div>
        );
    }

    return "";
};

export default Breaker;



// WEBPACK FOOTER //
// ./src/components/Breaker.js